import React, { useEffect, useCallback, useState} from 'react';
import {ChromePicker} from 'react-color';
import {connect} from 'react-redux';

const ZColorComponent = ({zcolor}) => { 
    let [color, setColor] = useState({hex: zcolor.color});

    useEffect(() => {
        zcolor.color = color.hex;
    }, [color]);
    return (
        <div className="z-color">
          <div
            onMouseDown={e => e.stopPropagation()}
            className="picker-container">
            <ChromePicker color={color} onChange={setColor}></ChromePicker>
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZColorComponent);
